import { render, staticRenderFns } from "./GroupNameButton.vue?vue&type=template&id=05a1e028&"
import script from "./GroupNameButton.vue?vue&type=script&lang=js&"
export * from "./GroupNameButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports